import { useRouter } from 'next/router'
import { useMachine } from '@xstate/react'

import HtmlHead from '_components/HtmlHead'
import LoginForm from '_components/LoginForm/LoginForm'

import loginMachine from '../machines/loginMachine'
import { useContext } from 'react'
import { AuthContext } from '../authContext'

const LoginPage = () => {
  const { updateCurrentUser } = useContext(AuthContext)
  const [current, send] = useMachine(loginMachine, {
    context: { updateCurrentUser },
  })
  const router = useRouter()
  const { redirectUrl } = router.query

  return (
    <div>
      <HtmlHead title="Login" />
      <div className="flex flex-col justify-center items-center h-screen bg-gray-100">
        <LoginForm current={current} send={send} redirectUrl={redirectUrl} />
      </div>
    </div>
  )
}

export default LoginPage
